/**
 * WalterGO Floating Action Bar
 * Handles expand/collapse toggle
 */
(function() {
  'use strict';

  const SELECTORS = {
    fab: '[data-waltergo-fab]',
    toggle: '[data-fab-toggle]'
  };

  const CLASSES = {
    expanded: 'is-expanded'
  };

  class FloatingActionBar {
    constructor() {
      this.fab = document.querySelector(SELECTORS.fab);
      if (!this.fab) return;

      this.toggle = this.fab.querySelector(SELECTORS.toggle);
      if (!this.toggle) return;

      this.isExpanded = false;
      this.bindEvents();
    }

    bindEvents() {
      // Toggle on button click
      this.toggle.addEventListener('click', () => this.toggleExpand());

      // Close on click outside
      document.addEventListener('click', (e) => {
        if (this.isExpanded && !this.fab.contains(e.target)) {
          this.collapse();
        }
      });

      // Close on ESC key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isExpanded) {
          this.collapse();
          this.toggle.focus();
        }
      });
    }

    toggleExpand() {
      if (this.isExpanded) {
        this.collapse();
      } else {
        this.expand();
      }
    }

    expand() {
      this.isExpanded = true;
      this.fab.classList.add(CLASSES.expanded);
      this.toggle.setAttribute('aria-expanded', 'true');
    }

    collapse() {
      this.isExpanded = false;
      this.fab.classList.remove(CLASSES.expanded);
      this.toggle.setAttribute('aria-expanded', 'false');
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new FloatingActionBar());
  } else {
    new FloatingActionBar();
  }
})();
